import { creditorSagas } from "./Creditor"
import { ManageCreditorSagas } from './ManageCreditors'
import {creditorCaseSagas} from './CreditorCases'

export default [
    ...creditorSagas,
    ...ManageCreditorSagas,
    ...creditorCaseSagas
]